<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">TP Benchmark</h4>
</div>

<div class="modal-body ey-privacy-notice-body">
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <p class="header"></p>
        <div class="body">
          <p *ngIf="isGenerativeAiEnabled">This TP Benchmark version contains generative AI and is not certified for use on Tax provisions.</p>
          <p *ngIf="!isGenerativeAiEnabled">This TP Benchmark version is audit certified for use on Tax provisions.</p>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-primary" [disabled]="!isActive" (click)="acknowledge()" title="Please scroll to the bottom to acknowledge.">
    Acknowledge
  </button>
  <button *ngIf="isGenerativeAiEnabled" type="button" class="btn btn-default" (click)="close()">Go to Tax Provision certified version</button>
  <button *ngIf="!isGenerativeAiEnabled" type="button" class="btn btn-default" (click)="close()">Go to Tax Provision non-certified AI version</button>
</div>
